import React from 'react';

/* Per-project schematic panel, drawn in the project's accent colour instead of
   a stock photo. `thumb` is the small card in a collapsed row; `poster` is the
   larger version that sits behind the live-site frame while it loads. */
const ProjectVisual = ({ project, variant = 'thumb' }) => {
  const { icon, lines = [], modules = [] } = project.visual || {};
  const Tag = variant === 'thumb' ? 'span' : 'div';

  if (variant === 'thumb') {
    return (
      <span className="proj-viz proj-viz--thumb">
        <span className="proj-viz-scan"></span>
        <span className="proj-viz-icon">
          <i className={icon}></i>
        </span>
        <span className="proj-viz-lines">
          {lines.map((line, i) => (
            <span key={line} className={i === 0 ? 'is-dim' : ''}>
              {i === 0 && <span className="proj-viz-bullet"></span>}
              {line}
            </span>
          ))}
        </span>
      </span>
    );
  }

  return (
    <Tag className="proj-viz proj-viz--poster">
      <span className="proj-viz-scan"></span>

      <div className="proj-viz-head">
        <span>SYS: ACTIVE</span>
        <span>MODE: PREVIEW</span>
        <span>{lines[0]}</span>
      </div>

      <div className="proj-viz-body">
        <i className={`${icon} proj-viz-glyph`}></i>
        <div className="proj-viz-name">{project.title}</div>
        <div className="proj-viz-sub">{lines.join('  ·  ')}</div>

        <div className="proj-viz-modules">
          {modules.map((m) => (
            <span key={m}>{m}</span>
          ))}
        </div>
      </div>
    </Tag>
  );
};

export default ProjectVisual;
